import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, lifecycle, withHandlers } from 'recompose';
import { SubmissionError } from 'redux-form';
import api from '../api';
import { getAuthenticatedAccountId } from '../selectors/auth';
import BabyEdit from '../components/BabyEdit';
import { getBabiesSortedByName } from '../selectors/babies';
import getNextBabyColor from '../helpers/getNextBabyColor';

export default compose(
  connect(
    state => ({
      accountId: getAuthenticatedAccountId(state),
      initialValues: {
        colorScheme: getNextBabyColor(getBabiesSortedByName(state).length)
      }
    }),
    dispatch =>
      bindActionCreators(
        {
          babiesCreate: api.actions.babiesCreate,
          babiesCreateReset: api.actions.babiesCreate.reset
        },
        dispatch
      )
  ),
  lifecycle({
    componentDidMount() {
      this.props.babiesCreateReset({});
    }
  }),
  withHandlers({
    onSubmit: ({
      accountId,
      babiesCreate,
      babiesCreateReset,
      onBabyCreated
    }) => values => {
      babiesCreateReset({});
      
      return babiesCreate(
        { accountId },
        {
          body: JSON.stringify({
            ...values,
            status: 'active',
            colorScheme: 'blue'
          })
        }
      ).then(
        () => {
          onBabyCreated();
        },
        () => {
          throw new SubmissionError({
            _error: 'accountOptions.addBabyError'
          });
        }
      );
    }
  })
)(BabyEdit);



// WEBPACK FOOTER //
// ./src/containers/BabyCreateContainer.js